/* eslint-disable no-undef */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Imagen from '../Imagen/Imagen';
import Botonera from '../Botonera/Botonera';
import useLoadImages from '../../hooks/useLoadImages';
import { generaListadoImagenes as generaListadoHorario } from '../../utils/generaListadoImagenes';

import moment from 'moment';
import Slider from '@mui/material/Slider';
import { Box } from '@mui/material';

import CircularProgress from '@mui/material/CircularProgress';
import CustomSlider from '../CustomSlider/CustomSlider';
import { imagenAnerior, imagenSiguiente, pause, reproducir, stop } from './controls';


//  "homepage": "https://www.inumet.gub.uy/reportes/pages/visualizador_ricm/"
const TITLE = "Visualizador RICM - INUMET"
const IMAGE_BASE_PATH = "https://www.inumet.gub.uy/reportes/ricm/"
const IMAGE_BASE_NAME_FORMAT = "YYYYMMDD"
const DATE_FORMAT_TO_DISPLAY = "DD/MM/YYYY"
const INTERVAL_IMAGES = [1, "days"]
const MAX_DATE_INTERVAL = [7, 'days']
const MIN_DATE = moment().subtract(10, "minutes")



const PlayerRicm = () => {
    const listadoHorario = useMemo(() => generaListadoHorario({ MIN_DATE, MAX_DATE_INTERVAL, IMAGE_BASE_NAME_FORMAT, INTERVAL_IMAGES }), [])
    const [listadoImagenes, setListadoImagenes] = useState([])
    const [fechaMuestra, setFechaMuestra] = useState(MIN_DATE.utc().format('DD/MM/YYYY HH:mm'))
    const [velocidad, setVelocidad] = useState(800)
    const [idReproduccion, setIdReproduccion] = useState(0)
    const [posicion, setPosicion] = useState(0);
    const [reproduciendo, setReproduciendo] = useState(0)



    const { images: imagenes_ricm, error: error_ricm, isLoading: isLoading_ricm, urls: urls_ricm } = useLoadImages(
        {
            prefijo: '',
            sufijo: '_rf',
            listadoImagenes: listadoHorario,
            posicion,
            extencion: 'png',
            IMAGE_BASE_PATH
        })



    const formatearFechaMuestra = useCallback(() => {
        if (listadoImagenes.length === 0) return
        const date = moment(listadoImagenes[posicion].dateTime, IMAGE_BASE_NAME_FORMAT)
        setFechaMuestra(date.format(DATE_FORMAT_TO_DISPLAY))

    }, [posicion, listadoImagenes])







    const generaListadoImagenes = useCallback(() => {
        const listadoImagenes = []
        listadoHorario.forEach((fecha) => {
            if (imagenes_ricm[fecha]) listadoImagenes.push({ ricm: imagenes_ricm[fecha], dateTime: fecha, urls_ricm: urls_ricm[fecha] })
        })
        setListadoImagenes(listadoImagenes)
    }, [imagenes_ricm, listadoHorario, urls_ricm])




    useEffect(() => {
        generaListadoImagenes()
    }, [imagenes_ricm, generaListadoImagenes])

    useEffect(() => {
        if (reproduciendo === 1) {
            setTimeout(() => {
                imagenSiguiente({ reproduciendo, listadoImagenes, posicion, setPosicion })
            }, velocidad)
        }
        formatearFechaMuestra()
    }, [reproduciendo, posicion, idReproduccion, velocidad, formatearFechaMuestra, listadoImagenes])

    useEffect(() => {
        document.title = TITLE
    }, [])


    if (isLoading_ricm || listadoImagenes.length < 1) return <Box
        sx={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
            justifyItems: "center",
        }}
    >
        <CircularProgress color="primary" />

    </Box>

    return (
        <Box
            sx={{
                maxWidth: "100vw",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Botonera
                stop={() => stop({ idReproduccion, setReproduciendo, setPosicion, setIdReproduccion })}
                pause={() => pause({ idReproduccion, setReproduciendo })}
                aumentarVelocidad={() => setVelocidad(velocidad - 100)}
                disminuirVelocidad={() => setVelocidad(velocidad + 100)}
                reproducir={() => reproducir({ reproduciendo, setReproduciendo })}
                imagenSiguiente={() => imagenSiguiente({ reproduciendo, listadoImagenes, posicion, setPosicion })}
                imagenAnerior={() => imagenAnerior({ listadoImagenes, posicion, setPosicion })}
                reproduciendo={reproduciendo}
            />

            <CustomSlider reproduciendo={reproduciendo} listadoImagenes={listadoImagenes} posicion={posicion} setPosicion={setPosicion} fechaMuestra={fechaMuestra} />

            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    maxWidth: "100vw",
                    maxHeight: "100vh",
                    justifyContent: "center",
                }}
            >
                <Imagen src={listadoImagenes[posicion].ricm} error={error_ricm} downloadLink={listadoImagenes[posicion].urls_ricm.replace('.png', '.tif')} />

            </Box>
        </Box>
    );
}

export default PlayerRicm
